import { render } from "./HomeContent.vue?vue&type=template&id=22d381d8&scoped=true"
import script from "./HomeContent.vue?vue&type=script&language=ts&lang=js"
export * from "./HomeContent.vue?vue&type=script&language=ts&lang=js"

import "./HomeContent.vue?vue&type=style&index=0&id=22d381d8&scoped=true&language=scss&lang=css"
script.render = render
script.__scopeId = "data-v-22d381d8"

export default script